/* src/app/components/lead-details/associations/provider-associations/provider-associations.component.css */
/*# sourceMappingURL=provider-associations.component-BMQUKBBI.css.map */
